import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllCenterProducts,
  loadSingleCenterProduct,
  setSingleCenterProductNotFound,
} from "./CenterProductsList.slice";

import {
  loadAllCenterProductsAPI,
  loadSingleCenterProductAPI,
} from "./CenterProductsList.api";

export const LOAD_ALL_CENTER_PRODUCTS = {
  LOADING: "Load all center product loading",
  SUCCESS: "Load all center product success",
  ERROR: "Load all center product error",
};

export const LOAD_SINGLE_CENTER_PRODUCT = {
  LOADING: "Load single center product loading",
  SUCCESS: "Load single center product success",
  ERROR: "Load single center product error",
};

function* loadAllCenterProductsWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllCenterProductsAPI, payload);
    yield put(loadAllCenterProducts(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_CENTER_PRODUCTS.ERROR, error });
  }
}

function* loadSingleCenterProductSagaWorker(action) {
  yield put(setSingleCenterProductNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleCenterProductAPI, payload);
    yield put(loadSingleCenterProduct(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleCenterProductNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_CENTER_PRODUCT.ERROR, error });
  }
}

export function* loadAllCenterProductsSaga() {
  yield takeLatest(
    LOAD_ALL_CENTER_PRODUCTS.LOADING,
    loadAllCenterProductsWorker
  );
}

export function* loadSingleCenterProductSaga() {
  yield takeLatest(
    LOAD_SINGLE_CENTER_PRODUCT.LOADING,
    loadSingleCenterProductSagaWorker
  );
}
